import { ResourceAvailabilitySource } from '@bemlo/enums'

import { Color } from '../../../../constants'
import { IconName } from '../../../../elements'
import { useTranslations } from '../../../../translate'
import { UIAvailability } from '../types'

const { VACATION, SCHEDULE } = ResourceAvailabilitySource

export const useAvailabilityStyle = (availability: UIAvailability[]) => {
  const t = useTranslations()

  const isOnVacation = availability.some(({ source }) => source === VACATION)
  const isBlocked = availability.some(
    ({ source, isAvailable }) => source === SCHEDULE && !isAvailable,
  )
  const isAvailable = availability.some(({ isAvailable }) => isAvailable)

  if (isBlocked || isOnVacation) {
    return {
      icon: (isOnVacation ? 'TentIcon' : 'BanIcon') as IconName,
      title: t.availability.unavailable(),
      subtitle: isOnVacation
        ? t.availability.vacation()
        : t.availability.blocked(),
      color: Color.CHARCOAL,
      backgroundColor: Color.GREY,
    }
  }

  return {
    icon: (isAvailable ? 'HandIcon' : 'XIcon') as IconName,
    title: isAvailable
      ? t.availability.available()
      : t.availability.non_preferred(),
    subtitle: undefined,
    color: isAvailable ? Color.DARK_GREEN : Color.DARK_RED,
    backgroundColor: isAvailable ? '#F7FFFA' : Color.WHITE,
  }
}
